/**
 * Вставка текста в поле ответа из соседних панелей.
 *
 * Поле ответа живёт в панели переписки, а кнопки «вставить статус заказа» —
 * в карточке контакта справа. Это соседи, а не родитель и потомок: тянуть
 * состояние поля наверх, в страницу инбокса, значило бы перерисовывать всю
 * страницу на каждую букву, которую печатает оператор.
 *
 * Поэтому маленькая шина: панель переписки подписывается, остальные шлют.
 */

type Listener = (text: string) => void;

const listeners = new Set<Listener>();

/** Подписаться на вставки. Возвращает функцию отписки. */
export function onComposerInsert(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Вставить текст в поле ответа активного тикета. */
export function insertIntoComposer(text: string): void {
  const trimmed = text.trim();
  if (!trimmed) return;
  for (const listener of listeners) listener(trimmed);
}
